// extracted by mini-css-extract-plugin
export default {"container":"LoadingMap_container__+3JQF","loaderContainer":"LoadingMap_loaderContainer__F1tm2"};